export default "__VITE_ASSET__TTtFCUo7__"